import "../../App.css";
import React from "react";
import CROWNS_BRIDGES from "../CROWNS_BRIDGES";
import CONTACT_US from "../footer";
import Accordian from "../../accordian/accordian";
import ScrollArrow from "../ScrollUp";
import BackBtn from "../BackBtn";

function CROWNS_BRIDGES_Page() {
  return (
    <>
      <CROWNS_BRIDGES />
      <Accordian
        title="How  Is a crown or bridge right for me I know If I need Orthodontics "
        content="  If you have a tooth that is harmed or rotted, yet intact, a dental crown might be appropriate for you. In the event that your tooth is missing, however its previous position is enclose by other tooth structures, an extension might be the answer for you. Take an appointment from the dental surgeon to decide if you really need crowns or extensions."
      />
      <Accordian
        title=" What should I expect when I have my crown or bridge placed"
        content="   An impression will then be taken of your teeth to manufacture a shape for the crown or extension. If you are picking porcelain prosthesis, its shading will be coordinated to the normal shade of your other teeth."
      />
      <Accordian
        title=" Do I need to follow any post treatment care guidelines"
        content="Your teeth will require time to restore strength following the crown and extension establishment process, so it is completely okay for you to encounter some sensitivity – particularly to hot and chilly. "
      />
      <BackBtn />
      <CONTACT_US />
      <ScrollArrow />
    </>
  );
}
export default CROWNS_BRIDGES_Page;
